// extracted by mini-css-extract-plugin
module.exports = {"container":"navigation__container___21T2_"};